//我的竞价
<template>
  <div>
    <header-img  :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">我的竞价</div>
      <choose-search @handleQuery="changeQuery"></choose-search>
      <div class="table">
        <el-table class="financial-services-table"  :data="tableData" v-loading="Loading"
            :header-cell-style="{ textAlign: 'center',  background: '#FAFAFA',  color: '#3F434B' }" :cell-style="{ textAlign: 'center' }"  >
            <el-table-column prop="name" label="标的名称"></el-table-column>
            <el-table-column prop="areaConfigName" label="区域"></el-table-column>
            <el-table-column prop="businessTypeDesc" label="业务类型"></el-table-column>
            <el-table-column  label="开始时间" width="150px">
              <template slot-scope="scope">{{scope.row.startTime | datetimeFormat}}</template>
            </el-table-column>
            <el-table-column  label="结束时间" width="150px">
              <template slot-scope="scope">{{scope.row.endTime | datetimeFormat}}</template>
            </el-table-column>
            <el-table-column prop="amount" label="竞价价格">
              <template slot-scope="scope">{{scope.row.amount+'元'+unitAppend(scope.row)}}</template>
            </el-table-column>
            <el-table-column prop="delistingStatus" label="竞价状态" width="70">
               <template slot-scope="scope">{{scope.row.delistingStatus == 0 ? '竞价中' : scope.row.delistingStatus == 1 ? '成功' : scope.row.delistingStatus == 2 ? '失败': ''}}</template>
            </el-table-column>
            <el-table-column prop="transactionAmount" label="交易服务费（元）">
              <template slot-scope="scope">{{!scope.row.transactionAmount ? '-' : scope.row.transactionAmount}}</template>
            </el-table-column>
          <el-table-column prop="transactionAmount" label="成交价款（元）">
            <template slot-scope="scope">{{!scope.row.transactionPrice ? '-' : scope.row.transactionPrice}}</template>
          </el-table-column>
            <el-table-column prop="payStatus" label="竞价操作">
               <template slot-scope="scope">
                 <span style="display: block;" v-if="scope.row.delistingStatus == 1 &&scope.row.transactionStatus == 0&&scope.row.businessType!=7 " class="blueC statusBtn" @click="payServiceFee(scope.row)">缴纳服务费</span>
                <span style="display: block;" v-if="scope.row.delistingStatus == 1 &&scope.row.priceStatus == 0&&scope.row.businessType!=7 " class="blueC statusBtn" @click="diaPayEvt(scope.row)">缴纳成交款</span>
                 <span v-if="scope.row.delistingStatus != 1||(scope.row.priceStatus == 1 &&scope.row.transactionStatus == 1)||scope.row.businessType==7">--</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="保证金状态">
              <template slot-scope="scope">
                 <span class="statusBtn">{{(scope.row.auditStatus == 1 && scope.row.amountStatus == 1 )? '已到账': scope.row.auditStatus == 2 ? '未到账': scope.row.auditStatus == 0 ? '审核中':'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="payStatus" label="保证金操作">
               <template slot-scope="scope">
                <span class="statusBtn blueC" v-if="scope.row.auditStatus == 2" @click="diaPayEvtS(scope.row)">重新支付</span>
                <span v-else>--</span>
              </template>
            </el-table-column> -->
        </el-table>
        <el-pagination style="text-align: center;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="search.pageNumber"
            :page-size="search.pageSize"
            layout="total, prev, pager, next,jumper"
            :total="total"></el-pagination>
      </div>
    </div>
    <!-- 竞价支付 -->
    <auctionDia :show.sync='diaShow' :data.sync='listItem'  @dialogCloses="diaShow = false" @diaSccessEvt="diaSccessEvt"></auctionDia>
    <repayDia :show.sync='repayDiaShow' :data.sync='listItem'  @repayDialogCloses="repayDiaShow= false" @repayDiaSccessEvt="repayDiaSccessEvt"></repayDia>
    <Dialog
        :show="diaJjShow"
        @dialogClose="diaJjShow = false"
        :img="'success.png'"
        :title="'温馨提示'"
        :content="contentMsg"
    />
    <!--支付服务费-->
    <payServiceFee @dialogCloses="payServiceShow = false" :show.sync='payServiceShow' :data.sync='listItem' @diaSccessEvt="diaSccessEvt"></payServiceFee>
  </div>
</template>

<script>
import ChooseSearch from '@/components/ChooseSearch/index.vue'
import Dialog from "@/components/Dialog";
import publicFunction from '@/utils/publicFunction'
import HeaderImg from "@/components/HeaderImg";
import Upload from "@/components/Upload/UpLoad.vue";
import auctionDia from './components/auctionDia.vue'
import payServiceFee from './components/payServiceFee.vue'
import repayDia from './components/repayDia.vue'
export default {
  components: {
    ChooseSearch,
    Dialog,
    HeaderImg,
    Upload,
    auctionDia,
    repayDia,
    payServiceFee
  },
  data() {
    return {
      headerList: [
        { name: "首页", path: "/Home" },
        { name: "我的竞价", }
      ],
      repayDiaShow: false,
      diaJjShow: false,
      contentMsg: "",
      diaShow: false,
      payServiceShow: false,
      Loading: false,
      tableData: [],
      search: {
        userId: this.$store.state.userInfo.id,
        pageNumber: 1,
        pageSize: 10,
        tranferType: 1
      },
      total: 0,
      listItem:{}
    }
  },
  watch: {
    fileUrl: {
      handler(newVal, oldVal) {
        if (newVal){
          this.formData.payEvidences.push({
            url: newVal,
            name: this.fileNameS
          });
          this.fileUrl = "";
        }
      }
    },
  },
  methods: {
    unitAppend:publicFunction.unitAppend,
    //重新支付
    diaPayEvtS(row){
      this.listItem = row
      this.repayDiaShow = true
    },
    repayDiaSccessEvt(v){
      this.repayDiaShow = v
      this.getTransactionList()
    },
    //缴纳服务费
    payServiceFee(row){
      if (!row.transactionAmount) {
        this.contentMsg = '由于未设置服务费，暂时无法支付'
        this.diaJjShow = true
        return
      }
      this.listItem = row
      this.payServiceShow = true
    },
    //缴纳成交款
    diaPayEvt(row){
      if (!row.transactionPrice) {
        this.contentMsg = '由于未设置成交价款，暂时无法支付'
        this.diaJjShow = true
        return
      }
      this.listItem = row
      this.diaShow = true
    },
    diaSccessEvt(v){
      this.diaShow = v
      this.payServiceShow = v
      this.getTransactionList()
    },
    //查询
    changeQuery(query) {
      if (query.chooseValue != 0) {
        this.$set(this.search, 'beginTime', query.chooseValue)
      } else {
        this.$set(this.search, 'beginTime', null)
        delete this.search.beginTime
      }
      if (query.searchValue) {
        this.$set(this.search, 'name', query.searchValue)
      } else {
        this.$set(this.search, 'name', null)
        delete this.search.name
      }
      this.search.pageNumber = 1
      this.getTransactionList()
    },
    getTransactionList() {
      this.Loading = true
      let data = JSON.parse(JSON.stringify(this.search))
      Object.keys(data).forEach(function(key) {
        if (data[key] === '') {
          delete data[key]
        }
      })
      this.$api.my.mypageAuctionlist(data).then((res) => {
        if (res.code == 1000) {
          this.tableData = []
          this.tableData = res.data
          this.total = res.total
        } else {
          this.$message.error(response.message)
        }
      }).catch((error) => {}).finally(()=>{
        this.Loading = false;
      })
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.getTransactionList()
    },
  },
  mounted() {
    this.getTransactionList()
  }
}
</script>
<style lang="scss" >
  .btn{
    text-align: center;
    margin: auto;
    display: block;
  }
 </style>
